//typed rcc then tab to have this generate from the snippets plugin
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
//import './contact.css';//can import individual css files this way
import { Consumer } from '../../context';
import axios from 'axios';

class Contact extends Component {
    state = {
        showContactInfo:false
    }
    onShowClick = e => {
        this.setState({showContactInfo:!this.state.showContactInfo})
    }
    onDeleteClick = async (id,dispatch)=>{
        try{
            await axios.delete(`https://jsonplaceholder.typicode.com/users/${id}`);
            dispatch({type: 'DELETE_CONTACT', payload:id});
        }catch(e){
            dispatch({type: 'DELETE_CONTACT', payload:id});
        }       
    }

    render() {
        const { contact } = this.props;
        const { showContactInfo } =  this.state;
        return (
            <Consumer>
                {value=>{
                    const {dispatch} = value;
                    return(
                        <div className="card card-body mb-3">
                            <h4>
                                {contact.name}&nbsp;    
                                <i onClick={this.onShowClick} className="fas fa-sort-down" style={{cursor:"pointer"}}/>
                                <i className="fas fa-times" style={{cursor:"pointer", float:"right", color:"red"}} 
                                    onClick={this.onDeleteClick.bind(this,contact.id,dispatch)}/>
                                <Link to={`contact/edit/${contact.id}`}>
                                    <i className="fas fa-pencil-alt"
                                        style={{
                                            cursor:"pointer",
                                            float:"right",
                                            color:"black",
                                            marginRight: "1rem"
                                        }}>
                                    </i>
                                </Link>
                                
                            </h4>
                            {showContactInfo ? (
                                <ul className="list-group">
                                    <li className="list-group-item">Email: {contact.email}</li>
                                    <li className="list-group-item">Phone: {contact.phone}</li>
                                </ul>       
                            ) : null
                            }
                        </div>
                    )
                }}
            </Consumer>

            
        )
    }
}

Contact.propTypes = {
   contact: PropTypes.object.isRequired
    //this is declaring the types of values and saying they
    //are required
}

export default Contact;